import { UsuarioDTO } from '../../../models/UsuarioDTO';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as jwtDecode from 'jwt-decode';
import { TokenService } from 'src/app/services/token.service';
import { CadastrarUsuarioDTO } from 'src/app/models/CadastrarUsuarioDTO';
import { RespostaPaginada } from 'src/app/models/Interface/RespostaPaginada';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  private userSubject = new BehaviorSubject<UsuarioDTO | null>(null);

  constructor(private http: HttpClient, private tokenService: TokenService) {
    // se nao chamar no construtor, ele irá sobrescrever com o valor da instancia acima
    if (tokenService.retornarToken()) {
      this.decodificarJwt();
    }
  }

  decodificarJwt() {
    const token = this.tokenService.retornarToken();
    const user = jwtDecode(token) as UsuarioDTO;
    // emite um evento no abservable
    this.userSubject.next(user);
  }

  retornaUser() {
    return this.userSubject.asObservable();
  }

  setUser(usuario: UsuarioDTO) {
    this.userSubject.next(usuario);
  }

  salvarToken(token: string) {
    this.tokenService.salvarToken(token);
    this.decodificarJwt();
  }

  logout() {
    this.tokenService.excluirToken();
    this.userSubject.next(null);
  }

  //cadastrar?login=meuLogin&senha=minhaSenha&cdCliente=123
  cadastrarUsuarioBack(usuario: CadastrarUsuarioDTO, login: string, senha: string, cdCliente: number) {
    return this.http.post(`${environment.urlApi}/usuarios?login=${login}&senha=${senha}&cdCliente=${cdCliente}`, usuario);
  }

  atualizarUsuarioBack(id: number, usuarioDtoback: CadastrarUsuarioDTO): Observable<any> {
    return this.http.put(`${environment.urlApi}/usuarios/${id}`, usuarioDtoback);
  }

  buscarUsuarioPorLoginECliente(login: string, cdCliente: string): Observable<UsuarioDTO> {
    return this.http.get<UsuarioDTO>(`${environment.urlApi}/usuarios/verificar?login=${login}&cdCliente=${cdCliente}`);
  }

  listarTodosUsuariosBack(pagina, totalItensPagina, colunaOrdenacao: string, direcaoOrdenacao: string, nomeUsuario?: string,
    idsArea?: any, ativo?: any, uf?: any, nomeCliente?: any) {
    let params = new HttpParams()
      .append('pagina', pagina)
      .append('totalItensPagina', totalItensPagina);

    if (idsArea) {
      idsArea.forEach(id => {
        params = params.append('idsAreasInteresse', id);
      });
    }
    params = colunaOrdenacao ? params.append('colunaOrdenacao', colunaOrdenacao) : params;
    params = direcaoOrdenacao ? params.append('direcaoOrdenacao', direcaoOrdenacao) : params;
    params = nomeUsuario ? params.append('nomeUsuario', nomeUsuario) : params;
    params = ativo != undefined ? params.append('ativo', ativo) : params;
    params = uf ? params.append('uf', uf) : params;
    params = nomeCliente ? params.append('nomeCliente', nomeCliente) : params;

    return this.http.get<RespostaPaginada>(`${environment.urlApi}/usuarios`, { params });
  }

  buscarUsuarioBack(id: number) {
    return this.http.get<UsuarioDTO>(`${environment.urlApi}/usuarios/${id}`);
  }

  excluirUsuario(id: number) {
    return this.http.delete(`${environment.urlApi}/usuarios/${id}`);
  }

  tornarAdmin(id: number) {
    return this.http.patch<UsuarioDTO>(`${environment.urlApi}/usuarios/alterar-perfil/${id}`, {});
  }
}
